import { useLang } from "@/lib/lang";
import { useAuth } from "@/lib/auth";

export default function QararkJordanWarning({ className = "" }) {
  const { t } = useLang();
  const { user } = useAuth();
  const country = user?.operating_country || "JO";
  if (country === "JO") return null;

  return (
    <div
      className={[
        "border border-amber-300 bg-amber-50 text-amber-950 px-4 py-3 text-sm leading-relaxed",
        className,
      ].join(" ")}
      data-testid="qarark-jordan-warning"
      role="status"
    >
      {t("qarark_jordan_only_warning")}
    </div>
  );
}
